import { MoreOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";

export const MoreOptionBtn = React.forwardRef(
  ({ displayText = false, icon, ...restProps }, ref) => {
    return (
      <Button
        ref={ref}
        type="text"
        icon={!icon ? <MoreOutlined /> : icon}
        {...restProps}
      >
        {displayText && "Opciones"}
      </Button>
    );
  },
);
